import Vue from 'vue'
import OpOnlineForm from '@oppein/op-web-form'
import opFlowComponent from "@oppein/op-flow-component";
import '@oppein/op-web-form/lib/op-web-form.css'
import "@oppein/op-flow-component/lib/op-flow-component.css";
import store from '@/store'

let env = 'pro'
switch (process.env.NODE_ENV) {
  case 'development':
    env = 'uat'
    break
  case 'uat':
    env = 'uat'
    break
  case 'ver':
    env = 'ver'
    break
  case 'production':
    env = 'pro'
    break
}
Vue.use(OpOnlineForm, { store, subAppCode: 'MMUCPC001', env })
Vue.use(opFlowComponent, { env })
